module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/mobile/dashkit-c4347d4a7af1820be43d2f1edcc7c868.jpg";